import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { DialogManager } from "../../Managers/DialogManager";
import { ApplicationData } from "../ApplicationData";
import { SimpleErrorDialog } from "../controls/simpleErrorDialog";
import { SuccessMessageControl } from "../controls/successMessageControl";
import { LS2PAC_Utils } from "../utils/Utils";
import { ResourceUtils } from "../utils/resourceUtils";
import { LS2PacSearchDatabaseManager } from "./SearchDatabaseManager";
import { TLCEventManager } from "src/main/resources/js/lib/events/EventManager";


export const PassThroughManager = function ( ) {

	var hasBeenInitialized = false;

	var getSection = function ( urlString ) {
		return getURLVar( "section", urlString );
	};

	var getTerm = function ( urlString ) {
		return getURLVar( "term", urlString );
	};

	var getReadingLevelFilters = function(urlString) {
		try {
			return JSON.parse(getURLVar("readingLevelFilters", urlString))
		}
		catch {
			return {}
		}
	}

	var getURLVar = function ( variable, urlString, defaultValue ) {
		defaultValue = defaultValue === undefined ? null : defaultValue;

		var urlValue = LS2PAC_Utils.getURLVar( variable, urlString );

		if( !urlValue ) {
			urlValue = defaultValue;
		}

		return urlValue;
	};

	function goHome() {
			TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onHome, {} );
	}

	var route = function ( section, urlString, override ) {
		
    if (getURLVar("showAccountLinkedMsg", urlString) === "true") {
      SuccessMessageControl.show(ApplicationData.language.successLinkingGoogleAccountMessage);
		}

		if (getURLVar("showAccountAlreadyLinkedMsg", urlString) === "true") {
			SimpleErrorDialog.show(ApplicationData.language.googleAccountAlreadyLinked);
		}

		var matched = false;
		switch( section.toLowerCase() ) {
			case "search": {
				

				const params = new URLSearchParams(window.location.hash.slice(1));
				const branchFiltersParam = params.get("branchFilters");
				const branchFilters = branchFiltersParam ? JSON.parse(branchFiltersParam) : [];
				const facetFiltersParam = params.get("facetFilters");
				const facetFilters = facetFiltersParam ? JSON.parse(facetFiltersParam) : [];
				const sortKey = params.get("sortKey");
				const pageParam = params.get("page");
				const page = pageParam ? parseInt(pageParam) : 0;
				const audienceParam = params.get("audience");
				const audience = audienceParam ? JSON.parse(audienceParam) : [];

				if(branchFiltersParam){
					ApplicationData.branchLimitsUtil.setLimitedBranches( branchFilters );
				}
				// var branchFilters = eval( getURLVar( "branchFilters", urlString ) );
				// if( branchFilters ) {
				// 	ApplicationData.branchLimitsUtil.setLimitedBranches( branchFilters );
				// }

				const db = params.get("db");

				// var db = getURLVar( "db", urlString );
				if( db && db.length > 0 ) {
					LS2PacSearchDatabaseManager.setCurrentDatabaseKey( db );
				}

				const department = params.get("department") || "";
				const instructor = params.get("instructor") || "";
				const course = params.get("course") || "";

				// const term = getTerm( urlString );
				const term = params.get("term");
				try {
					const termObject = JSON.parse(term);
					// term is an object...

					if(termObject.isReadingLevel){
						// reading level search
						// TODO pass readingLevelFilters in the URL
						const readingLevelFilters = getReadingLevelFilters(urlString);
						
						TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onSearch, {
							searchString: JSON.stringify(termObject),
							readingLevelFilters,
							databaseKey: db,
							branchFilters:                  branchFilters,
							facetFilters: facetFilters,
							sortKey: sortKey,
							page: page,
							audienceCharacteristicsFilters: audience,
							department:                     department,
							course:                         course,
							instructor:                     instructor
						} );
					}
					else {
						TLCEventManager.fireEvent(  LS2PAC_CONSTANTS.Events.onSearch, {
							searchString: JSON.stringify(termObject),
							databaseKey: db,
							branchFilters:                  branchFilters,
							facetFilters: facetFilters,
							sortKey: sortKey,
							page: page,
							audienceCharacteristicsFilters: audience,
							department:                     department,
							course:                         course,
							instructor:                     instructor
						} );
					}

					

					
					
				}
				catch(e){
					

					// term is not an object
					TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onSearch, {
						databaseKey: db,
						// searchString:                   getTerm( urlString ),
						searchString: term,
						noHistory:                      true,
						branchFilters:                  branchFilters,
						// facetFilters:                   eval( getURLVar( "facetFilters", urlString ) ),
						facetFilters: facetFilters,
						// sortKey:                        getURLVar( "sortKey", urlString ),
						sortKey: sortKey,
						// page:                           parseInt( getURLVar( "page", urlString ), 10 ),
						page: page,
						// audienceCharacteristicsFilters: eval( getURLVar( "audience", urlString, [] ) ),
						audienceCharacteristicsFilters: audience,
						department:                     department,
						course:                         course,
						instructor:                     instructor
						//TODO searchType:
					} );
				}

				

				matched = true;
				break;
			}
			case "resource":
				var resourceId = getURLVar( "resourceid", urlString );
				var hostRecordId = getURLVar( "hostRecordId", urlString );
				var viewName = getURLVar( "view", urlString );
				if( resourceId ) {
					TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onViewResource, {
						resourceId: resourceId,
						viewName:   viewName
					} );
				} else if( hostRecordId ) {
					TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onViewResource, {
						hostRecordId: hostRecordId,
						viewName:     viewName
					} );
				}
				matched = true;

				break;
			case "error":
				handleError( urlString );
				matched = true;
				break;
			case "resetpin":
				matched = true;
				break;
			default:
				break;
		}
		return matched;
	};

	function handleError( urlString ) {
		var errorType = getURLVar( "type", urlString );
		var errorString = "There was an unknown error";
		var errorTitle = "System Error";
		var okText = ApplicationData.language.ok;
		var showCancel = false;
		var submitCallback = function () {
			goHome();
		};

		switch( errorType ) {
			case "ssoError":
				errorTitle = ApplicationData.language.ssoErrorTitle;
				errorString = ApplicationData.language.ssoError;
				okText = ApplicationData.language.close;
				break;
			case "ssoErrorStack":
				errorTitle = ApplicationData.language.ssoErrorTitle;
				if( window.SPRING_SECURITY_LAST_EXCEPTION_MESSAGE != "" ) {
					errorString = window.SPRING_SECURITY_LAST_EXCEPTION_MESSAGE + "<br><br>";
				}
				if( window.SPRING_SECURITY_LAST_EXCEPTION_CAUSE != "" ) {
					errorString += window.SPRING_SECURITY_LAST_EXCEPTION_CAUSE;
				}
				okText = ApplicationData.language.close;
				break;
			default:
				break;
		}

		DialogManager.show( {
			content:        errorString,
			dialogTitle:    errorTitle,
			okText:         okText,
			cancelText:     ApplicationData.language.close,
			showCancel:     showCancel,
			submitCallback: submitCallback,
			closeCallback:  function ( event ) {
				goHome();
			}
		} );
	}

	var goToMyAccount = function ( eventArguments ) {
		if( eventArguments.subView == "requests" ) {
			eventArguments.subView = "holds";
		}
		TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onMyAccount, eventArguments );
	};

	var checkURL = function ( override, overrideURL ) {
		var url = (override) ? overrideURL : window.location.search.substring( 1 );
		var section = getSection( url );
		if( section !== null ) {
			return route( section, url, override );
		} else {
			url = (override) ? overrideURL : window.location.hash.substring( 1 );
			section = getSection( url );
			if( section !== null ) {
				return route( section, url, override );
			}

		}
		return false;
	};

	/*
	 * This listener will get tripped by the libraryThing tag browser functionality.
	 * the first time a user clicks a tag it will redirect the browser and work as expected.
	 * However if they use the tag browser again it will just change the # tag value and not fire the search.
	 * If we here this event we know the URL has changed to something we haven't seen before so it will try to
	 * run the pass through logic for us.  We have to make sure the app has been initialized first though.
	 *
	 */
	TLCEvents.on( TLC_CONSTANTS.Events.noHistoryFound, function ( event ) {
		TLCLogger.log( "#####no history found", event );
		if( hasBeenInitialized ) {
			checkURL();
		}
	} );

	return {
		init:     function () {
			hasBeenInitialized = true;
			return checkURL();
		},
		checkURL: function ( overrideURL ) {
			return checkURL( true, overrideURL );
		}
	};

}( );
